<template>
    <div class="language-en header-top nav-item-page  nav-myccount-loggedin">
        <!-- Main Navigation Bar - Sticky -->
        <div class="sticky-nav-wrapper">
            <div class="logo-wrapper top-logo-wrapper">
                <div class="d-flex px-0 menu-nav-wrapper">
                    <div class="navContainerSec">
                        <div class="mobileFlexible">
                            <a href="/">
                                <img :src="require('@/assets/images/logo_u134.png')" class="logoNoPrice" alt="Tron">
                            </a>
                        </div>

                        <section class="nav-bar-section">
                            <div class="new-menu-List">
                                <nav class="top-header-bar navbar navbar-expand-md navbar-dark" style="padding: 0px;">
                                    <div class="collapse navbar-collapse" id="navbar-top">
                                        <ul class="navbar-nav single-language-navbar-nav">
                                            <a class="nav-link home-link active" aria-current="page" href="/">
                                                <span class="menu-active-tile-border menu-active-tilte-pc">
                                                    <span>家</span>
                                                    <span class="menu-active-bottom-border"></span>
                                                </span>
                                            </a>                                            
                                        </ul>
                                    </div>
                                </nav>
                            </div>

                            <div class="loginInfoNavBar">
                                <div class="navbar navbar-expand-md navbar-dark py-0 page-right-navbar mainetMargin mobileMarginMenu justify-content-end">
                                    <section class="navbar-nav navbar-right wallet-nav justify-content-center align-items-center">
                                        <div class="d-flex">
                                            <ul>
                                                <li class="nav-static nav-static-login dropdown token_black nav">
                                                    <a class="nav-link nav-link-name">                                                        
                                                        <span class="myaccount-nickname">USDT钱包交易记录查询</span>
                                                    </a>                                                    
                                                </li>
                                            </ul>
                                        </div>                                        
                                        <div class="ant-dropdown-trigger nav-notice-content">
                                            <svg class="icon tron-icon nav-notice-icon" aria-hidden="true">
                                                <use xlink:href="/static/media/icons.svg#icon-icon-notice"></use>
                                            </svg>
                                            <span class="new-notice-mark"></span>
                                        </div>
                                        <div class="drawWrapper hidden-PC" @click="showDrawer">
                                            <svg class="icon tron-icon tron-mobile-more" aria-hidden="true">
                                                <use xlink:href="/static/media/icons.svg#icon-icon-right-more"></use>
                                            </svg>
                                        </div>
                                    </section>                                    
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Desktop Search Bar -->
        <div class="nav-searchbar hasactiveComponent dark-hasactive-component" style="padding-top: 87px;">                        
            <div class="homeNotice container-fluid position-relative d-flex mx-auto flex-column ">
                <TronAnnouncements />
            </div>

            <div id="navSearchbarId hidden-mobile">
                <div class="container p-0 index-page-search-sec d-flex justify-content-between">
                    <div class="searchAndHotSec">
                        <div class="row justify-content-center text-center">
                            <div class="col-12">
                                <div class="nav-searchbar hidden-mobile" style="width: 100%;">
                                    <div class="input-group dropdown">
                                        <section class="input-wrapper d-flex">
                                            <span class="ant-input-group-wrapper form-control box-shadow-none newSearchInput input-search-focus" style="border: 1px solid transparent;">
                                                <a-input-group compact>
                                                    <a-input
                                                        v-model:value="addressDesktop"
                                                        @keyup.enter="handleSearch"
                                                        class="ant-input ant-input-borderless"
                                                        style="width: 100%; padding: 0 0 0 6px;"
                                                        placeholder="按代币/账户地址搜索">
                                                        <template #prefix>
                                                            <search-outlined />
                                                        </template>

                                                        <template #suffix>
                                                            <span v-if="addressDesktop" class="ant-input-clear-icon ant-input-clear-icon ant-input-clear-icon-has-suffix" role="button" tabindex="-1" @click="addressDesktop = ''">
                                                                <span role="img" aria-label="close-circle" class="anticon anticon-close-circle">
                                                                <svg fill-rule="evenodd" viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                                    <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
                                                                </svg>
                                                                </span>
                                                            </span>
                                                            <span v-if="addressDesktop" class="ant-input-clear-icon ant-input-clear-icon ant-input-clear-icon-has-suffix" role="button" tabindex="-1" @click="handleSearch">
                                                                <svg class="icon tron-icon tron-icon-search-quick" aria-hidden="true">
                                                                    <use xlink:href="/static/media/icons.svg#icon-search-quick"></use>
                                                                </svg>
                                                            </span>
                                                            
                                                        </template>
                                                    </a-input>
                                                </a-input-group>
                                            </span>
                                                                                        
                                        </section>
                                        <div class="dropdown-menu" id="_searchBox" v-show="showSearchHistory">
                                            <div class="search-history-wrap">
                                                <div class="search-history-cont">
                                                    <div class="search-history">
                                                        <h5>
                                                            <span>
                                                                <span>Search History</span>
                                                            </span>
                                                            <span class="deleteicon">
                                                                <span>Delete all records</span>
                                                            </span>
                                                        </h5>
                                                        <ul>
                                                            <li class="searchList">
                                                                <span class="searchResult">
                                                                    <div class="truncate-ellipsis">
                                                                        <span>TN1ZiKn2GdMgLcVvVALysR1j9hPGBMoAf2</span>
                                                                    </div>
                                                                </span>
                                                                <span class="searchDelete">
                                                                    <span>Delete</span>
                                                                </span>
                                                            </li>
                                                            <li class="searchList">
                                                                <span class="searchResult">
                                                                    <div class="truncate-ellipsis">
                                                                        <span>TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t</span>
                                                                    </div>
                                                                </span>
                                                                <span class="searchDelete">
                                                                    <span>Delete</span>
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="hotSearch container-fluid position-relative d-flex mx-auto flex-column hidden-mobile">
                            <div class="container pc-home-splash p-0">
                                <div class="row text-center noticeNewsBox">
                                    <div class="col-12 exchange noticeNews home-hot-search">
                                        <section class="d-flex searchCont">
                                            <span class="hot-search-title">
                                                <span>热门搜索</span>: </span>
                                            <ul class="hot-token">
                                                <li class="list-token">
                                                    <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-hot-token-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-usdt"></use>
                                                        </svg>
                                                        <svg class="icon tron-icon tron-v-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-v"></use>
                                                        </svg>
                                                    </b>
                                                    <a class="" href="/">USDT</a>
                                                </li>
                                                <li class="list-token">
                                                    <img width="14" height="14" alt="" loading="lazy" src="https://static.tronscan.org/production/upload/logo/new/sun/TXL6rJbvmjD46zeN1JssfgxvSo99qC8MRT.png">
                                                    <a class="" href="/">SUNDOG</a>
                                                </li>
                                                <li class="list-token">
                                                    <img width="14" height="14" alt="" loading="lazy" src="https://static.tronscan.org/production/upload/logo/new/TAt4ufXFaHZAEV44ev7onThjTnF61SEaEM.png?t=1724787343170">
                                                    <a class="" href="/">BULL</a>
                                                </li>
                                                <li class="list-token">
                                                    <img width="14" height="14" alt="" loading="lazy" src="https://static.tronscan.org/production/upload/logo/TPeoxx1VhUMnAUyjwWfximDYFDQaxNQQ45.JPG">
                                                    <a class="" href="/">TBULL</a>
                                                </li>
                                                <li class="list-token">
                                                    <img width="14" height="14" alt="" loading="lazy" src="https://static.tronscan.org/production/upload/logo/new/sun/TAwAg9wtQzTMFsijnSFotJrpxhMm3AqW1d.jpeg">
                                                    <a class="" href="/">SUNCAT</a>
                                                </li>
                                                <li class="list-token">
                                                    <img width="14" height="14" alt="" loading="lazy" src="https://static.tronscan.org/production/upload/logo/new/sun/TP3prcvQknVthrVnn281cKST56eWiLgJJM.png">
                                                    <a class="" href="/">SUNWUKONG</a>
                                                </li>
                                                <li class="list-token">
                                                    <img width="14" height="14" alt="" loading="lazy" src="https://static.tronscan.org/production/upload/logo/new/sun/TX5eXdf8458bZ77fk8xdvUgiQmC3L93iv7.png">
                                                    <a class="" href="/">PUSS</a>
                                                </li>
                                                
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="profitSec hidden-mobile">
                        <div class="profit-box homepage-profit">
                            <div class="profit-main loading">
                                <svg class="icon tron-icon" aria-hidden="true">
                                    <use xlink:href="/static/media/icons.svg#icon-icon-loding"></use>
                                </svg>
                            </div>
                            <div class="common-profit-wapper" id="profitWrapper">                                
                                <a v-if="adSmallData" :href="adSmallData.ad_link" target="_blank" rel="noopener">
                                    <img :src="`/static/${adSmallData.ad_image}`" alt="Advertisement" style="width:100%; height:auto;" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="nav-searchbar hasactiveComponent hottokenComponent hidden-PC">
            <div id="navSearchbarMobileId" class="input-group dropdown mobile-group-search">
                <div class="search-input">        
                    <input v-model="addressMobile" type="text" @keyup.enter="handleSearch" placeholder="请输入需要查询的钱包地址">
                    <button @click="handleSearch" :disabled="loading" class="ml-2 px-4 py-2 text-white rounded">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search-icon text-white">
                            <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
    import TronAnnouncements from '@/components/TronAnnouncements.vue';
    import { Input, message } from 'ant-design-vue';
    import { mapState } from 'vuex';    
    import { h } from 'vue';
    
    export default {
        name: "TronHeader",        
        data() {
            return {
                loading: false,
                showSearchHistory: false,
                addressDesktop: '',
                addressMobile: '',
                address: '',
                adSmallData: null,
            }
        },
        components: {
            TronAnnouncements,            
            'a-input': Input,
            'a-input-group': Input.Group,
        },
        watch: {
            addressDesktop(val) {
                this.showSearchHistory = !!val;
            },
        },
        mounted() {
            fetch('/ads_small.json')
            .then(res => res.json())
            .then(data => {                
                this.adSmallData = data;
            })
            .catch(err => {
                console.error("Failed to load ad JSON:", err);
            });
        },
        methods: {
            showDrawer() {
                //console.log('Show Drawer');
                this.$store.dispatch('setShowDrawer', true);
            },
            handleSearch() {
                //console.log('Desktop Entered: ', this.addressDesktop);
                //console.log('Mobile Entered: ', this.addressMobile);
                                
                if ((this.addressDesktop && this.addressDesktop.trim()) || this.addressMobile && this.addressMobile.trim()) {
                    const activeAddress = this.addressDesktop?.trim() || this.addressMobile?.trim();
                    this.address = activeAddress;
                    this.$router.push(`/address/${this.address.trim()}`);
                    this.addressDesktop = '';
                    this.addressMobile = '';
                }
            },

            copyToClipboard(address) {
                navigator.clipboard.writeText(address).then(() => {
                    //this.$message.success("地址已复制到剪贴板");
                    this.$message.success({
                        content: h('div', [
                            h('div', '地址已复制到剪贴板 ✅'),
                            h('div', { style: 'font-weight: bold; word-break: break-all;' }, address),
                        ]),
                        duration: 3,
                    });
                }).catch(err => {
                    this.$message.error("复制失败");
                    console.error(err);
                });
            },
        }
    }
</script>

<style scoped>

.search-input {
    width: calc(100% - 48px); 
    max-width: 90vw;  
    min-width: 300px; 

    align-items: center;
    background:rgb(0, 0, 0);
    border: none;
    border-radius: 72px;
    display: flex;
    height: 40px;
    padding: 0 16px;

    margin: 5px auto;
    display: flex;       
    
    input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: transparent;
      border: none;
      border-radius: 0;
      box-shadow: none;
      color: #fff;
      flex: 1 1;
      font-size: 14px;
      line-height: 16px;
      margin: 0 0 0 12px;
      outline: 0;
      overflow: hidden;
      resize: none;
      text-overflow: ellipsis;
      white-space: nowrap;
    }  

}    
</style>